import { Portal, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';

import { useMember } from 'modules/common/queries/member';
import useAuthHandlers from 'modules/Auth/AuthProvider/useAuthHandlers';
import { IMPERSONATION_TRANSITION_PATH } from 'modules/Auth/AuthProvider/constants';

export default function StopImpersonatingButton() {
    const { impersonateEnd } = useAuthHandlers();
    const { data: member } = useMember();

    const history = useHistory();

    const stopImpersonating = async () => {
        history.push(IMPERSONATION_TRANSITION_PATH);
        await impersonateEnd();
    };

    return (
        <Portal disablePortal={!member?.hasPaymentIssue}>
            <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={stopImpersonating}
                sx={{
                    ...(member?.hasPaymentIssue && {
                        position: 'fixed',
                        top: {
                            xs: 30,
                            sm: 20,
                            md: 20,
                        },
                        right: { xs: 'auto', md: 270 },
                        left: { xs: 20, md: 'auto' },
                        zIndex: ({ zIndex }) => zIndex.modal + 1,
                    }),
                    ...(!member?.hasPaymentIssue && {
                        ml: { xs: 'auto', sm: 1, md: 2 },
                    }),
                }}>
                Stop Impersonating
            </Button>
        </Portal>
    );
}
